import React from 'react';
import { MoonIcon } from '@chakra-ui/icons';
import { IconButton, useColorMode } from '@chakra-ui/react';

const DarkModeToggle = (): React.ReactElement => {
  const { toggleColorMode } = useColorMode();
  return (
    <IconButton
      mx='8px'
      colorScheme='descomplica'
      aria-label='Toggle Dark Mode'
      variant='ghost'
      icon={<MoonIcon />}
      onClick={toggleColorMode}
    />
  );
};

export default DarkModeToggle;
